import React, { useState, useEffect } from "react"
import { Button, Col, Row } from "react-bootstrap"
import {
  doc,
  deleteDoc,
  collection,
  getDocs,
  query,
  updateDoc,
} from "firebase/firestore"
import { db } from "../../Firebase/config"
import Notify from "../Componentslogic/Usenotifications"
import Modal from "react-bootstrap/Modal"

export const Adminmenucard = ({ products, onEdit, onDelete }) => {
  const [show, setShow] = useState(false)
  const [purchaseCount, setPurchaseCount] = useState(0) // New state for purchase count
  const [available, setAvailable] = useState(products.available ?? true) // Track availability
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  useEffect(() => {
    const fetchPurchaseCount = async () => {
      try {
        const q = query(collection(db, "Orders"))
        const querySnapshot = await getDocs(q)

        let totalCount = 0
        querySnapshot.forEach((orderDoc) => {
          const cartItems = orderDoc.data().cartItems || []
          cartItems.forEach((item) => {
            if (item.name === products.name) {
              totalCount += item.CartTotalQuantity || 0 // Sum quantities for the matching product
            }
          })
        })

        setPurchaseCount(totalCount) // Update the state with the total count
      } catch (error) {
        console.error("Error fetching purchase count:", error)
      }
    }

    fetchPurchaseCount()
  }, [products.name])

  // Function to handle marking product as available/unavailable
  const handleToggleAvailability = async () => {
    try {
      const productRef = doc(db, "Products", products.id)
      await updateDoc(productRef, { available: !available }) // Toggle availability

      setAvailable(!available) // Update state immediately
      Notify(
        `Product marked as ${!available ? "Available" : "Unavailable"}`,
        "success"
      )
    } catch (error) {
      console.error("Error updating availability")
      Notify("Failed to update product status", "error")
    }
  }

  const handleDelete = async () => {
    try {
      await deleteDoc(doc(db, "Products", products.id))
      Notify("Product deleted", "success")
      onDelete(products.id) // Call the parent handler to update local state
      setShow(false)
    } catch (error) {
      console.error("Error deleting product:", error)
    }
  }

  return (
    <div className="Review-Card-F mb-5">
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Confirm Delete </Modal.Title>
        </Modal.Header>
        <Modal.Body>are you sure you want to delete {products.name}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Row>
        <Col sm="11">
          <h3 className="Product-title">{products.name}</h3>
          <span>
            Purchased: <b> {purchaseCount}</b> times
          </span>
          <p>
            <strong>
              {products.categoryName ? products.categoryName : null}
            </strong>
          </p>
          <p className="mb-3">{products.description}</p>
        </Col>

        <Col sm="12">
          <h4>
            Price:{products.Price ? products.Price : products.sizes[0].Price}{" "}
            EGP
          </h4>

          <div className="bottom-part-Edit mt-4">
            <button className=" btns-Admin " onClick={onEdit}>
              Edit
            </button>
            <Button
              variant={available ? "success" : "secondary"}
              onClick={handleToggleAvailability}
            >
              {available ? "Available" : "Unavailable"}
            </Button>
          </div>
          <div className="d-flex justify-content-end mt-5 ">
            <img
              onClick={handleShow}
              className="nxtimg"
              src="delete.png"
              alt="deleteicon"
            />
          </div>
        </Col>
      </Row>
    </div>
  )
}
